import { IListView, IListViewItem, EventSources } from "@optima-stride-ai/optima-components";
import { BizInformationTypes, FieldTypes, IFieldMeta } from "@optima-stride-ai/core";

export function getAdditionalFieldsListView(
    fields: IFieldMeta[],
    onSettingsClick: (item: IListViewItem<IFieldMeta>) => void,
    onDeleteClick: (item: IListViewItem<IFieldMeta>) => void
): IListView<IFieldMeta> {
    const colHeaders = [
        { key: "col1", label: "Icon", cssClass: "icon-label", tooltip: "Field icon" },
        { key: "col2", label: "Field Name", cssClass: "name-label", tooltip: "Field name" },
        { key: "Edit", label: "Edit", cssClass: "edit-label", tooltip: "Edit" },
        { key: "Delete", label: "Delete", cssClass: "delete-label", tooltip: "Delete" }
    ];

    const listViewItems: IListViewItem<IFieldMeta>[] = getAdditionalFieldsListViewItems(
        fields,
        onSettingsClick,
        onDeleteClick
    );

    const listView: IListView<IFieldMeta> = {
        title: '',
        colHeaders: colHeaders,
        items: listViewItems,
        isStriped: true,
        headerActions: []
    };

    return listView;
}

function getAdditionalFieldsListViewItems(
    fields: IFieldMeta[],
    onSettingsClick: (item: IListViewItem<IFieldMeta>) => void,
    onDeleteClick: (item: IListViewItem<IFieldMeta>) => void
): IListViewItem<IFieldMeta>[] {
    return fields.map((field, index) => ({
        id: field.name || `field-${index}`,
        data: field,
        columns: [           
            { 
                key: "col1", 
                label: "Icon", 
                value: field.icon, 
                metaData: { name: "col1", label: "Icon", type: FieldTypes.text }, 
                bizInformationType: BizInformationTypes.icon 
            },
            { 
                key: "col2", 
                label: "Field Name", 
                value: field.name, 
                metaData: { name: "col2", label: "Field Name", type: FieldTypes.text }, 
                bizInformationType: BizInformationTypes.text 
            }
        ],
        actions: [
            {
                label: 'Edit',
                icon: 'cilCog',
                tooltip: 'Edit field settings',
                action: (item) => {
                    if (item) onSettingsClick(item);
                },
                eventSource: EventSources.Click
            },
            {
                label: 'Delete',
                icon: 'cilTrash',
                tooltip: 'Delete this field',
                action: (item) => {
                    if (item) onDeleteClick(item);
                },
                eventSource: EventSources.Click
            }
        ]
    }));
}